import React, { useEffect, useState } from "react";
import {
  ButtonText,
  FlexColumn,
  FlexRow,
  FormInputField,
  LargeButton,
  Text,
  FormSelectField,
  FlexRowFluid,
} from "../../../../../styles/Global";
import * as Global from "../../../../../styles/Global";
import StatBlock from "../../../../player/StatBlock";
import { Controller } from "react-hook-form";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiFillInstagram, AiOutlineCloseCircle } from "react-icons/ai";
import { BsFacebook } from "react-icons/bs";
import { connect, useSelector } from "react-redux";
import { setModal } from "../../../../../features/modals/modalSlice";
import { BiEdit, BiMessage } from "react-icons/bi";
import { MdOpenInNew } from "react-icons/md";
import { OpenExternalURL } from "../../../../../functions/helperFunctions";
import { FormControl, InputLabel, MenuItem } from "@mui/material";
import { godPowerDateOptions } from "../../../forms/formSelectArrays";

const mapDispatch = {
  setModal,
};

const GodPowerSearchOptions = ({
  setModal,
  dataCallBody,
  setDataCallBody,
  windowWidth,
}) => {
  const platform = useSelector((state) => state.organizer.platform);
  const isOrgView =
    new URLSearchParams(window.location.search).has("uid") &&
    new URLSearchParams(window.location.search).get("uid") !== "";

  return (
    <FlexRowFluid
      align="center"
      style={{ flex: 0 }}
      direction={isOrgView && windowWidth < 700 ? "column" : "row"}
    >
      {isOrgView ? (
        <FlexRow
          align="center"
          justify="center"
          style={{
            // backgroundColor: "#f5f5f5",
            border: `1px solid ${Global.red}`,
            borderRadius: "5px",
            padding: "8px 8px 8px 12px",
            cursor: "pointer",
            marginBottom: "5px",
            flex: 0,
            marginTop: 5,
            marginLeft: 5,
          }}
          onClick={() => {
            const url = new URL(window.location);
            url.searchParams.delete("uid");
            window.history.replaceState({}, "", url); // Reset dataCallBody to initial state

            console.log("setting dataCallBody reset: ", {
              ...dataCallBody,
              dateGte: "now/d",
              dateLte: "now+3d/d",
              accountid: null,
            });
            setDataCallBody({
              ...dataCallBody,
              dateGte: "now/d",
              dateLte: "now+3d/d",
              accountid: null,
              type: null,
            });
          }}
        >
          <FlexColumn>
            <Text size="0.9em">Showing results for organizer ID:</Text>
            <Text color={Global.redLight} size="0.9em">
              {new URLSearchParams(window.location.search).get("uid")}
            </Text>
          </FlexColumn>
          <AiOutlineCloseCircle
            style={{
              marginLeft: 8,
            }}
            size={20}
            color={Global.red}
          />
        </FlexRow>
      ) : (
        <FormControl
          size="small"
          style={{
            marginTop: 8,
            marginLeft: 5,
          }}
        >
          <InputLabel id="chooseSportInputLabel" className="selectInputSmall">
            Choose Range
          </InputLabel>
          <FormSelectField
            labelId="sport-select-label"
            id="sportSelect"
            label="Choose Range"
            defaultValue={"now+3d/d"}
            onChange={(e) => {
              console.log("e.target.value: ", e.target.value);
              const value = e.target.value; // Check if the value contains a plus sign

              if (value.includes("+")) {
                setDataCallBody({
                  ...dataCallBody,
                  dateGte: "now/d",
                  dateLte: value,
                  endUnixTime: value,
                });
              } else {
                setDataCallBody({
                  ...dataCallBody,
                  dateGte: value,
                  dateLte: "now/d",
                  endUnixTime: value,
                });
              } // Sort is now handled by the useEffect
            }}
            value={dataCallBody.endUnixTime}
            sx={{
              borderRadius: 10,
              marginBottom: 1,
            }}
          >
            {godPowerDateOptions.map((o, i) => {
              return (
                <MenuItem
                  key={i.toString()}
                  style={{
                    fontSize: ".8em",
                    fontWeight: "500",
                  }}
                  value={o.id}
                >
                  {o.name}
                </MenuItem>
              );
            })}
          </FormSelectField>
        </FormControl>
      )}
      <LargeButton
        style={{ padding: "5px 10px", borderRadius: 5, marginLeft: 5 }}
        onClick={() =>
          setModal({
            orgModals: {
              showModal: true,
              data: {},
              modalType: 53,
            },
          })
        }
      >
        <ButtonText style={{ fontSize: ".8em" }}>Message</ButtonText>
        <BiMessage size={15} color={"#fff"} style={{ marginLeft: 5 }} />
      </LargeButton>
    </FlexRowFluid>
  );
};

export default connect(null, mapDispatch)(GodPowerSearchOptions);
